import { render, staticRenderFns } from "./MessagesTable.vue?vue&type=template&id=6cd16d20&scoped=true&"
import script from "./MessagesTable.vue?vue&type=script&lang=js&"
export * from "./MessagesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd16d20",
  null
  
)

export default component.exports